import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import HomeIcon from "@mui/icons-material/Home";
import QuizIcon from "@mui/icons-material/Quiz";
import AssessmentIcon from '@mui/icons-material/Assessment';
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import BarChartIcon from '@mui/icons-material/BarChart';
import React from "react";
import { NavLink } from "react-router-dom";



function BottomNavigation() {

  const footerLinks = [
    { to: "/dashboard", Icon: HomeIcon, title: "Home" },
    { to: "/jobs", Icon: BusinessCenterIcon, title: "Jobs" },
    { to: "/applicants", Icon: GroupAddIcon, title: "Applicants" },
    { to: "/insightscontainer", Icon: SupervisorAccountIcon, title: "Task" },
    { to: "/insights", Icon: BarChartIcon, title: "Insights" },
    { to: "/report", Icon: AssessmentIcon, title: "Report" },
  ]


  return (
    <div className="footer">
      <div className="footer_container">
        {footerLinks.map(({ to, Icon, title }) => (
          <NavLink
            key={to}
            to={to}
            style={{ textDecoration: "none" }}
            className={({ isActive }) => (isActive ? "selected" : "unselected")}
          >
            <div className="footerOption">
              <Icon />
              <h4 className="footerOption_title">{title}</h4>
            </div>
          </NavLink>
        ))}
      </div>
    </div>
  );
}

export default BottomNavigation;
